<template lang="pug">
  v-dialog(v-model='showModal' max-width='580px' @click:outside='closeDialog()')
    v-card(style='max-width: 100%;' v-if="!displayErrorModal")
      v-toolbar.toolbar-settings.text-settings(style='z-index: 99999')
        span(style='font-size: 1.125rem; line-height: 1.4em; font-weight: 300; font-size: 18px;') {{ modalTitle() }}
        v-spacer
        v-btn#closeIcon(icon color='white' @click='closeDialog()')
          md-icon close
      v-card-text.content-dialog
        v-form(ref='form')
          v-text-field(
            :rules="[rules.required]"
            v-model="item.name"
            :disabled="viewOnly"
            filled
            density="compact"
            style='margin-top: 40px;'
            :placeholder="$t('managementAccess.profileName')"
          )
          v-text-field(
            :rules="[rules.required]"
            density="compact"
            :disabled="viewOnly"
            v-model="item.description"
            :placeholder="$t('managementAccess.description')"
            filled
          )
          v-autocomplete(
            :rules="[rules.atLeastOne]"
            v-model="item.functions"
            :items="availableItems"
            hide-selected
            :disabled="viewOnly"
            :menu-props='viewOnly ? "": "openOnClick"'
            density="comfortable"
            :label='$t("managementAccess.functionalityRelatedToProfile")'
            :no-data-text='$t("managementAccess.noMoreFunctionalities")'
            multiple)
            template(v-slot:selection='data')
              v-hover(v-slot:default="{ hover }")
                v-chip(style='background-color: #ff9800; border-color: #ff9800; color: black!important; transition: 0.5s' v-bind='data.attrs' :input-value='data.text' small)
                  | {{ data.item }}
                  v-icon(v-if='!viewOnly' @click='removeItem(data.item)' style='margin-left: 4px;') mdi-close
          div(v-if="!viewOnly")
            v-card-actions.text-right
              v-btn(@click='closeDialog()' color='#A8A8A8' style='color: white; margin-right: 10px') {{ $t('templates.cancel') }}
              v-btn(
                @click='saveItem()'
                :disabled="false"
                color='#43a047'
                style='color: white;') {{ $t('templateEditDialog.save') }}
    v-card(v-else)
      SimpleModal(
        :showModal="displayErrorModal"
        max-width='700px'
        scrollable
        lButtonColor='#A8A8A8'
        rButtonColor='#6BA652'
        :lButtonTitle="$t('managementAccess.cancel')"
        @clickLButton='closeDialog()'
        showRButton
        showLButton
        :rButtonTitle="simpleModalRightButton"
        @clickRButton='retryRequest()'
      )
        template(slot='content')
          v-col
            v-row(style='justify-content: center;')
              ErrorCircle
            v-row(style='justify-content: center;')
              h2 {{ errorRequestMessage }}

</template>

<script>
import cloneDeep from 'lodash.clonedeep'
import Swal from 'sweetalert2'
import SimpleModal from '@/components/Reuse/SimpleModal.vue'
import ErrorCircle from '@/assets/img/error-circle.svg'

export default {
  components: {
    SimpleModal,
    ErrorCircle
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    functionList: {
      type: Array,
      default: () => []
    },
    itemData: {
      type: Object,
      default: () => {
      }
    },
    requestUrl: {
      type: String,
      default: ''
    },
    method: {
      type: String,
      default: 'POST'
    },
    viewOnly: {
      type: Boolean,
      default: false
    }
  },
  created () {
    this.availableItems = cloneDeep(this.functionList)
    if (this.item) {
      this.item = cloneDeep(this.itemData)
    }
    this.handleMessages()
  },
  data () {
    return {
      rules: {
        required: (v) => !!v || this.$t('commonPhrases.requiredField'),
        atLeastOne: (v) => v.length > 0 || this.$t('managementAccess.atLeastOne')
      },
      item: {
        name: '',
        description: '',
        functions: []
      },
      selectedItems: [],
      availableItems: [],
      displayErrorModal: false,
      successRequestMessage: this.$t('managementAccess.roleCreated'),
      errorRequestMessage: this.$t('managementAccess.roleCreateError'),
      simpleModalRightButton: this.$t('managementAccess.createAgain')
    }
  },
  methods: {
    modalTitle () {
      if (this.method === 'post') {
        return this.$t('managementAccess.createProfile')
      }
      return this.$t('managementAccess.editRole')
    },
    closeDialog () {
      if (this.displayErrorModal) {
        this.displayErrorModal = false
        this.$emit('closeModal')
        return
      }
      this.$refs.form.reset()
      this.displayErrorModal = false
      this.$emit('closeModal')
    },
    async saveItem () {
      try {
        if (this.$refs?.form?.validate() || this.displayErrorModal) {
          await this.$axios[this.method](this.requestUrl, this.item).then(() => {
            Swal.fire({
              icon: 'success',
              title: this.successRequestMessage,
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.closeDialog()
              this.$emit('successOnSave')
            })
          })
        }
      } catch (error) {
        this.displayErrorModal = true
      }
    },
    retryRequest () {
      this.saveItem()
    },
    removeItem (item) {
      for (let i = 0; i < this.item?.functions?.length; i++) {
        if (item === this.item?.functions[i]) {
          this.item.functions.splice(i, 1)
        }
      }
    },
    handleMessages () {
      if (this.method === 'post') {
        this.successRequestMessage = this.$t('managementAccess.roleCreated')
        this.errorRequestMessage = this.$t('managementAccess.roleCreateError')
        this.simpleModalRightButton = this.$t('managementAccess.createAgain')
      } else {
        this.successRequestMessage = this.$t('managementAccess.roleUpdated')
        this.errorRequestMessage = this.$t('managementAccess.roleUpdateError')
        this.simpleModalRightButton = this.$t('managementAccess.updateAgain')
      }
    }
  },
  watch: {
    functionList: {
      handler (val) {
        this.availableItems = cloneDeep(val)
      },
      deep: true
    },
    itemData: {
      handler (val) {
        this.item = {
          name: val.name,
          description: val.description,
          functions: val.functions
        }
      },
      deep: true
    },
    method: {
      handler () {
        this.handleMessages()
      }
    }
  }
}
</script>
